import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { bootstrapMsalMailcall } from './msalBootstrap';

// OAuth dönüşünde handleRedirectPromise yalnızca burada bir kez çalışsın (React Strict Mode çift effect / null token sorunu)
bootstrapMsalMailcall().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  // StrictMode dev'de effect'leri iki kez çalıştırır; MSAL handleRedirectPromise ikinci kez null döner.
  root.render(<App />);
});
